export default __webpack_public_path__ + "static/media/35.9d2a8599.jpg";